import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"
import {
  getAnalyticsConsent,
  initPosthogIfConsented,
  optOutPosthog,
  setAnalyticsConsent,
} from "@/lib/analytics"

/** GDPR opt-in cookie banner — analytics off until accept. */
export function CookieConsent() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const existing = getAnalyticsConsent()
    if (existing === "accepted") {
      initPosthogIfConsented()
      setVisible(false)
      return
    }
    if (existing === "rejected") {
      optOutPosthog()
      setVisible(false)
      return
    }
    setVisible(true)
  }, [])

  if (!visible) return null

  const accept = () => {
    setAnalyticsConsent("accepted")
    initPosthogIfConsented()
    setVisible(false)
  }

  const reject = () => {
    setAnalyticsConsent("rejected")
    optOutPosthog()
    setVisible(false)
  }

  return (
    <div className="fixed bottom-0 inset-x-0 z-[100] p-4 pointer-events-none">
      <div className="mx-auto max-w-3xl rounded-2xl border border-border bg-card p-4 shadow-none pointer-events-auto flex flex-col sm:flex-row gap-4 items-start sm:items-center">
        <p className="text-sm text-muted-foreground flex-1">
          Folosim cookie-uri esențiale pentru autentificare. Analytics (PostHog) doar cu
          consimțământul tău.{" "}
          <Link to="/legal/privacy" className="underline text-foreground">
            Politica de confidențialitate
          </Link>
        </p>
        <div className="flex gap-2 shrink-0">
          <Button variant="outline" size="sm" className="rounded-full" onClick={reject}>
            Doar esențiale
          </Button>
          <Button size="sm" className="rounded-full" onClick={accept}>
            Accept analytics
          </Button>
        </div>
      </div>
    </div>
  )
}
